module.exports = __webpack_public_path__ + "img/generic-ventilator.0eec85db.png";